import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './Wizard.module.css';
import CardComponent from '../Card/Card';
import PageTitleBarComponent from "../PageTitleBar/PageTitleBar";
import CarouselComponent from '../Carousel/Carousel';

export default function WizardComponent(props) {
    const isShowMemories = props.pageTitle === 'Achievements & Memories';

    const path = isShowMemories ? 'memory' : 'project';

    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState(props.data);

    useEffect(() => {
      document.getElementById('all').checked = true;    
    }, []);
    
    function getDistinctValuesWithCount(arr) {
        const counts = {};

        arr.forEach(item => {
            counts[item] = (counts[item] || 0) + 1;
        });

        const result = [];
        for (const value in counts) {
            result.push({ value, count: counts[value] });
        }

        return result;
    }

    const tagsArray = props.data.map(x => x.tag);
    const distinctTagsWithCount = getDistinctValuesWithCount(tagsArray);

    const onFilterRadioChanged = (e) => {
        const selectedOption = e.currentTarget.value;

        if (selectedOption === 'all') {
            setFilteredData(props.data);
        } else {
            const newData = props.data.filter(x => x.tag === selectedOption);
            setFilteredData(newData);
        }
    }

    return (
        <>
            <PageTitleBarComponent pageTitle={props.pageTitle} />

            <form className={styles.techs + ' section_content'}>
                <span>
                    <input type="radio" id='all' name="tech_filter" value='all' onChange={onFilterRadioChanged} />
                    <label className={styles.chip} htmlFor='all'>  All </label>
                </span>

                {
                    distinctTagsWithCount.map((item, index) =>
                        <span key={index}>
                            <input type="radio" id={item.value} name="tech_filter" value={item.value} onChange={onFilterRadioChanged} />
                            <label className={styles.chip} htmlFor={item.value}>  {item.value} </label>
                        </span>
                    )
                }
            </form>

            {
                filteredData?.map(item =>
                    <section className={styles.wizardContainer} key={item.id} onClick={() => navigate(`/details/${path}/${item.id}`)}>
                        <button>
                            <CardComponent hideThumbnail={false} item={item.card} />
                        </button>
                        <CarouselComponent isSmallSize={isShowMemories} thumbnailImages={item.images} />
                    </section>)
            }
        </>
    )
}
